import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RestService } from 'src/providers/rest.service';

declare var $: any;

@Component({
  selector: 'app-aktarildi-isaretle-modal',
  templateUrl: './aktarildi-isaretle-modal.component.html',
  styleUrls: ['./aktarildi-isaretle-modal.component.css']
})
export class AktarildiIsaretleModalComponent implements OnInit {

  modalData: number = null;
  faturaId: number;
  
  @Output() updateList = new EventEmitter<boolean>();
  
  @Input()
  public set source(id: number) {
    if (id != null) {
      this.faturaId = id;
    }
  }

  @Input()
  public set show(ts: number) {
    if (ts) {
      if (this.modalData !== ts) {
        this.modalData = ts;
        $('#aktarildi-isaretle-modal').modal('show');
      }
    }
  }

  constructor(private restService: RestService) { }

  ngOnInit() {
  }

  modalKapat(){
    $('#aktarildi-isaretle-modal').modal('hide');
  }

  aktarildiIsaretle(){
    this.restService.aktarildiIsaretle(this.faturaId).subscribe(res => {
      this.updateList.emit(true);
      this.modalKapat();
    })
  }
}
